import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Discounts from "./Discounts";
import { privateAPI } from "../../../utils/api";
import { DiscountsWrapper } from "./styles";

const CreateEditUserDiscount = ({ ...props }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [products, setProducts] = useState([]);

  const getProducts = async () => {
    try {
      const response = await privateAPI.get(`/auth/bacchus/admin/product`);
      setProducts(response.data);
    } catch (error) {
      throw new Error(error)
    }
  };

  useEffect(() => {
    getProducts();
  }, []);

  return (
    <Dialog
      fullScreen={fullScreen}
      open={props.open}
      onClose={props.closeCreateUserDiscount}
      aria-labelledby="responsive-dialog-title"
    >
      <DialogTitle
        id="responsive-dialog-title"
        align="center"
        style={{ color: "#001753", marginBottom: "15px" }}
      >
        Add discount
      </DialogTitle>
      <DialogContent>
        <Box
          component="form"
          sx={{ display: "flex", flexDirection: "column", padding: "10px" }}
          style={{ minWidth: "300px" }}
          autoComplete="off"
        >
          <DiscountsWrapper>
            {products
              ? products.map((item) => (
                  <Discounts
                    products={products}
                    setUserDiscounts={props.setUserDiscounts}
                    userDiscounts={props.userDiscounts}
                    userDTO={props.userDTO}
                    item={item}
                    key={item.id}
                  />
                ))
              : "You don't have a products"}
          </DiscountsWrapper>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={props.closeCreateDiscountDialog}>
          Close
        </Button>
        <Button
          onClick={props.editDiscounts}
          autoFocus
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateEditUserDiscount;
